import React from 'react';
import DojoMemberStatusSelector from './DojoMemberStatusSelector';

export default function DojoNutritionIndicators(props) {
  return <DojoMemberStatusSelector {...props} label="Nutrition" nutrition />;
}
